var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.698 10.5836H19.8447C18.1707 10.5836 16.8133 11.941 16.8133 13.6154V16.0181H15.3021C15.1849 16.0181 15.09 16.1129 15.09 16.2301V18.722C15.09 18.8392 15.1849 18.9341 15.3021 18.9341H16.8133V19.0666V27.2047C16.8133 27.3215 16.9081 27.4167 17.0253 27.4167H20.0474C20.1646 27.4167 20.2594 27.3219 20.2594 27.2047V18.9337H22.4504C22.5606 18.9337 22.6523 18.8497 22.6617 18.7398L22.8724 16.2479C22.8828 16.1241 22.7852 16.0181 22.661 16.0181H20.2594V14.2502C20.2594 13.8358 20.5953 13.5 21.01 13.5H22.6983C22.8155 13.5 22.9104 13.4051 22.9104 13.2879V10.796C22.91 10.6785 22.8152 10.5836 22.698 10.5836Z",
    fill: "url(#paint0_linear_9_2735)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C8.50637 0 0 8.50672 0 19C0 29.4936 8.50672 38 19 38C29.4933 38 38 29.4933 38 19C38 8.50672 29.4933 0 19 0ZM19 35.3954C9.95932 35.3954 2.60457 28.0403 2.60457 19C2.60457 9.95932 9.95967 2.60457 19 2.60457C28.0403 2.60457 35.3954 9.95967 35.3954 19C35.3954 28.0407 28.0403 35.3954 19 35.3954Z",
    fill: "url(#paint1_linear_9_2735)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_2735",
    x1: 5.19589,
    y1: 6.01731,
    x2: 33.562,
    y2: 31.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_2735",
    x1: 4.81728,
    y1: 6.44486,
    x2: 33.1835,
    y2: 31.5559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000C55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008BE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.beabfeebd81a0dd5db89212271918f7e.svg";
export { ForwardRef as ReactComponent };